<template>
  <div class="chat-wrapper">
    <dispatchChatPanel
      v-if="showStatus"
      :pushTextItem="pushTextItem"
    ></dispatchChatPanel>
    <template v-else>
      <userChatPanel
        v-if="singleMap[currentChat]"
        :chatItem="chatItem"
        :segmentationTime="segmentationTime"
        :Index="Index"
        :list="list"
      ></userChatPanel>
      <group-chat-panel 
        v-else 
        :chatItem="chatItem" 
        :segmentationTime="segmentationTime"
        :Index="Index"
        :list="list"
      />
    </template>
  </div>
</template>

<script>
import userChatPanel from "./chat-content-panel/user-chat-panel";
import dispatchChatPanel from "./chat-content-panel/dispatch-push-panel";
import groupChatPanel from "./chat-content-panel/group-chat-panel.vue";
import { mapGetters } from 'vuex'

export default {
  props: [
    "chatItem",
    "segmentationTime",
    "Index",
    "pushTextItem",
    "showStatus",
    "list",
    "currentChat"
  ],
  components: {
    userChatPanel,
    dispatchChatPanel,
    groupChatPanel,
  },
  computed: {
    ...mapGetters('im', ['singleMap', 'teamsMap']),
    isShowDispatchPush() {
      return (
        this.pushTextItem.module == "dispatch" &&
        this.pushTextItem.type == "notify"
      );
    },
  },
};
</script>
<style lang="scss" scoped></style>
